import getParameterByName from '../../utils/query-params';

const state = {
  isLti: false,
  ltiAuthToken: '',
  ltiContext: null,
};

const mutations = {
  setIsLti(state, isLti) { state.isLti = isLti; },
  setLtiAuthToken(state, authToken) { state.ltiAuthToken = authToken; },
  setLtiContext(state, context) { state.ltiContext = context; },
};

const actions = {
  initializeLtiParams({ commit }) {
    const ltiParam = getParameterByName('lti');
    const paramToken = getParameterByName('token');
    const ltiContext = getParameterByName('lticontext');
    commit('setIsLti', ltiParam === 'true');
    commit('setLtiAuthToken', paramToken);
    commit('setLtiContext', ltiContext);
  },
};

const getters = {
  isLti({ isLti }) {
    return isLti;
  },
  ltiAuthToken({ ltiAuthToken }) {
    return ltiAuthToken;
  },
  ltiContext({ ltiContext }) {
    return ltiContext;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/lti/lti.js